interface CheckIconProps {
  color: string;
}

const CheckIcon = ({ color }: CheckIconProps) => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6601 0.387148C15.9855 0.712581 15.9855 1.24022 15.6601 1.56566L6.29089 10.9349C5.93291 11.2928 5.35251 11.2928 4.99453 10.9349L0.339412 6.27969C0.0139786 5.95427 0.0139786 5.42661 0.339412 5.10119C0.664845 4.77577 1.19249 4.77577 1.51792 5.10119L5.64271 9.22594L14.4816 0.387148C14.807 0.061706 15.3347 0.061706 15.6601 0.387148Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckIcon;
